import axios from '../../axios-api';
import Pathes from '../../helpers/pathes';
import { getMessage, getQuery } from '../../helpers/utils';
import { GET_BLOG_ARTICLES } from '../types/blogTypes';

const getBlogArticlesRequest = () => ({ type: GET_BLOG_ARTICLES.REQUEST });
const getBlogArticlesSuccess = payload => ({
  type: GET_BLOG_ARTICLES.SUCCESS,
  payload,
});
const getBlogArticlesFailure = error => ({
  type: GET_BLOG_ARTICLES.FAILURE,
  error,
});

// TODO find solution for pagination-query sync
export const getBlogArticles = params => {
  return dispatch => {
    dispatch(getBlogArticlesRequest());
    return axios
      .get(Pathes.Blog.articles + getQuery(params))
      .then(response => {
        const { status, data } = response;
        const message = getMessage(data);
        if (status === 200) {
          dispatch(getBlogArticlesSuccess(data));
          return { data, success: true, message };
        }

        throw new Error(message);
      })
      .catch(e => dispatch(getBlogArticlesFailure(e.message)));
  };
};
